const normalize_id = (value) => String(value ?? "");

export default {
  name: "FormalDocumentEntityTypeSelector",
  props: {
    entity_types: {
      type: Array,
      default: () => [],
    },
    locked_entity_type_id: {
      type: [Number, String],
      default: null,
    },
    selected_entity_type_ids: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["toggle"],
  data: () => ({
    entity_type_search: "",
  }),
  computed: {
    selected_entity_type_id_map() {
      return new Set(
        (this.selected_entity_type_ids || []).map((entity_type_id) =>
          normalize_id(entity_type_id)
        )
      );
    },
    selected_entity_types() {
      return (this.entity_types || []).filter((entity_type) =>
        this.selected_entity_type_id_map.has(normalize_id(entity_type.id))
      );
    },
    filtered_entity_types() {
      const search_term = String(this.entity_type_search || "").trim().toLowerCase();
      const rows = [...(this.entity_types || [])].sort((left_item, right_item) =>
        String(left_item.entity_type_name || "").localeCompare(
          String(right_item.entity_type_name || "")
        )
      );
      if (!search_term) {
        return rows;
      }
      return rows.filter((entity_type) =>
        String(entity_type.entity_type_name || "")
          .toLowerCase()
          .includes(search_term)
      );
    },
  },
  methods: {
    is_selected(entity_type_id) {
      return this.selected_entity_type_id_map.has(normalize_id(entity_type_id));
    },
    is_locked(entity_type_id) {
      return normalize_id(entity_type_id) === normalize_id(this.locked_entity_type_id);
    },
    toggle(entity_type_id) {
      this.$emit("toggle", entity_type_id);
    },
  },
};
